// Map zoom functionality using Zoomist v2
import Zoomist from 'zoomist'

document.addEventListener('turbolinks:load', function() {
  
  const mapButton = document.querySelector('.map-button');
  const mapModal = document.getElementById('mapModal');
  const zoomistContainer = document.getElementById('zoomistContainer');
  
  if (!mapModal || !zoomistContainer) return;
  
  let zoomistInstance = null;
  
  // Initialize Zoomist when modal opens
  const initializeZoomist = function() {
    if (zoomistInstance) {
      zoomistInstance.destroy();
    }
    
    // Create Zoomist instance
    zoomistInstance = new Zoomist(zoomistContainer, {
      // Basic options
      maxScale: 4,
      minScale: 0.5,
      initScale: 1,
      
      // Enable touch gestures
        slider: true,
        zoomer: false,
        smooth: true,
      
      // Bounds
      bounds: true,
      
      // Wheel zoom
      wheel: {
        disabled: false,
        factor: 0.1
      },
      
      // Touch/pinch options
      pinch: {
        disabled: false,
        factor: 0.3
      },
      
      // Drag options
      drag: {
        disabled: false
      }
    });
    
    console.log('Zoomist initialized');
  };
  
  // Handle modal opening
  if (mapButton) {
    mapButton.addEventListener('click', function(e) {
      e.preventDefault();
      console.log('Map button clicked');
      
      // Show modal
      if (window.bootstrap && window.bootstrap.Modal) {
        const modal = new window.bootstrap.Modal(mapModal);
        modal.show();
      } else if (window.$ && window.$.fn.modal) {
        window.$(mapModal).modal('show');
      } else {
        // Fallback: manually show modal
        mapModal.style.display = 'block';
        mapModal.classList.add('show');
        document.body.classList.add('modal-open');
        
        // Add backdrop
        const backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        document.body.appendChild(backdrop);
      }
      
      // Initialize Zoomist after a short delay to ensure modal is rendered
      setTimeout(initializeZoomist, 200);
    });
  }
  
  // Handle modal close
  const closeButton = mapModal.querySelector('.btn-close');
  if (closeButton) {
    closeButton.addEventListener('click', function() {
      // Destroy Zoomist instance
      if (zoomistInstance) {
        zoomistInstance.destroy();
        zoomistInstance = null;
      }
      
      // Close modal
      if (window.bootstrap && window.bootstrap.Modal) {
        const modal = window.bootstrap.Modal.getInstance(mapModal);
        if (modal) modal.hide();
      } else if (window.$ && window.$.fn.modal) {
        window.$(mapModal).modal('hide');
      } else {
        // Manual close
        mapModal.style.display = 'none';
        mapModal.classList.remove('show');
        document.body.classList.remove('modal-open');
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) backdrop.remove();
      }
    });
  }
  
  // Also handle Bootstrap modal events
  mapModal.addEventListener('shown.bs.modal', function() {
    setTimeout(initializeZoomist, 100);
  });
  
  mapModal.addEventListener('hidden.bs.modal', function() {
    if (zoomistInstance) {
      zoomistInstance.destroy();
      zoomistInstance = null;
    }
  });
});